import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';

/**
 * InputOrderFormHidden for any form.
 */

class InputOrderFormHidden extends React.Component {
	constructor(props) {
	    super(props);
	    this.state = {isFilled: false, hasError: false, errorMsg:''};
	}
	componentDidMount() {
		if(this.props.value!=='') {
			this.fieldInput.value = this.props.value;
		}
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		this.props.onChange(this.fieldInput, this.state.hasError, this.props.itemkey);
	}
	
    render () {
    	const id = uniqueId('input_'); 
		return (
			<div className="orderformhidden">
				<input autoCapitalize="off" autoCorrect="off" id={id} type="hidden" name={this.props.name} ref={(input) => { this.fieldInput = input; }}  />
				
			</div>
		)
    }

}
InputOrderFormHidden.propTypes = {
	
	/** InputOrderFormHidden value */
	value: PropTypes.string,
	/** InputOrderFormHidden value */
	itemkey: PropTypes.string
}


InputOrderFormHidden.defaultProps = {
  value: "",
  itemkey: ""
}

export default InputOrderFormHidden;


// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormHidden.js